export const SET_SCHOOLS_PARTNERS = "SET_SCHOOLS_PARTNERS";
export const SET_SCHOOLS_PARTNERS_ERROR = "SET_SCHOOLS_PARTNERS_ERROR";
export const SET_SCHOOLS_PARTNERS_LOADING = "SET_SCHOOLS_PARTNERS_LOADING";
export const SET_SCHOOLS_PARTNERS_FETCHING = "SET_SCHOOLS_PARTNERS_FETCHING";
export const SET_CREATED_SCHOOL_PARTNER = "SET_CREATED_SCHOOL_PARTNER";
export const SET_UPDATED_SCHOOL_PARTNER = "SET_UPDATED_SCHOOL_PARTNER";
export const REMOVE_DELETED_SCHOOL_PARTNER = "REMOVE_DELETED_SCHOOL_PARTNER";
